import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";
import Select from 'react-select';
import DatePicker from 'react-date-picker';
import { toast } from 'react-toastify';

import { consultaGeneral, consultaEstados, consultaCiudMunic, consultaParroquia,
    calculaEdad, ConsultaDisp } from '../../../funciones/PefilFunction';

let fecha = new Date();
let tName = "";

class DatosPersonales extends Component {
    state = {
        selectNac: { value: 'V', label: 'V' },
        valorSex: { value: 'M', label: 'Masculino' },
        ced: { text:"Cédula de Identidad", status: "" },
        cedula: { text: "", status: "", disabled: "disabled" },
        pasaporte: { text: "", status: "", disabled: "disabled" },
        nombres: { text: "Nombres", status: "" },
        nombre1: { text: "", status: "", disabled: "disabled" },
        nombre2: { text: "", status: "", disabled: "disabled" },
        apellidos: { text: "Apellidos", status: "" },
        apellido1: { text: "", status: "", disabled: "disabled" },
        apellido2: { text: "", status: "", disabled: "disabled" },
        calle: { text: "", status: "", disabled: "disabled" },
        casa: { text: "", status: "", disabled: "disabled" },
        telefonos: { text: "Teléfonos", status: "" },
        tlf1: { text: "", status: "", disabled: "disabled" },
        tlf2: { text: "", status: "", disabled: "disabled" },
        tlf3: { text: "", status: "", disabled: "disabled" },

        paices: [{ value: '', label: ' - Cargando Lista - ' }],
        selectPais: { value: '', label: ' - Selecciona un Pais - ', status: "" },
        estados: [],
        selectEstado: { value: '', label: ' - Selecciona un Estado - ', status: "" },
        ciudades: [],
        selectCiudad: { value: '', label: ' - Selecciona una Ciudad - ', status: "" },
        municipios: [],
        selectMunicipio: { value: '', label: ' - Selecciona un Municipio - ', status: "" },
        parroquias: [],
        selectParroquia: { value: '', label: ' - Selecciona una Parroquia - ', status: "" },
        fechaTit: { text: "* Fecha de Nacimiento", status: "" },
        fecha: fecha,
        fechaStatus: "",
        fechaFormat: "",
        etnia: { text:"", status: "", disabled: "disabled" },

        paicesDir: [{ value: '', label: ' - Cargando Lista - ' }],
        selectPaisDir: { value: '', label: ' - Selecciona un Pais - ', status: "" },
        estadosDir: [],
        selectEstadoDir: { value: '', label: ' - Selecciona un Estado - ', status: "" },
        ciudadesDir: [],
        selectCiudadDir: { value: '', label: ' - Selecciona una Ciudad - ', status: "" },
        municipiosDir: [],
        selectMunicipioDir: { value: '', label: ' - Selecciona un Municipio - ', status: "" },
        parroquiasDir: [],
        selectParroquiaDir: { value: '', label: ' - Selecciona una Parroquia - ', status: "" },

        calle: { text: "", status: "", disabled: "disabled" },
        casa: { text: "", status: "", disabled: "disabled" },
        telefonos: { text: "Teléfonos", status: "" },
        tlf1: { text: "", status: "", disabled: "disabled" },
        tlf2: { text: "", status: "", disabled: "disabled" },
        tlf3: { text: "", status: "", disabled: "disabled" },

        cedRepre: { text:"Cédula de Identidad", status: "" },
        cedulaRepre: { text: "", status: "", disabled: "disabled" },
        pasaporteRepre: { text: "", status: "", disabled: "disabled" },
        nombresRepre: { text:"Nombres", status: "" },
        nombre1Repre: { text:"", status: "", disabled: "disabled" },
        nombre2Repre: { text:"", status: "", disabled: "disabled" },
        apellidosRepre: { text: "Apellidos", status: "" },
        apellido1Repre: { text: "", status: "", disabled: "disabled" },
        apellido2Repre: { text: "", status: "", disabled: "disabled" },
        calleRepre: { text: "", status: "", disabled: "disabled" },
        casaRepre: { text: "", status: "", disabled: "disabled" },
        emailRepre: { text: "", status: "", disabled: "disabled" },
        telefonosRepre: { text: "Teléfonos", status: "" },
        tlf1Repre: { text: "", status: "", disabled: "disabled" },
        tlf2Repre: { text: "", status: "", disabled: "disabled" },
        tlf3Repre: { text: "", status: "", disabled: "disabled" },

        selectPaisRepre: { value: '', label: ' - Selecciona un Pais - ', status: "" },
        paicesRepre: [{ value: '', label: ' - Cargando Lista - ' }],
        selectEstadoRepre: { value: '', label: ' - Selecciona un Estado - ', status: "" },
        estadosRepre: [],
        selectCiudadRepre: { value: '', label: ' - Selecciona una Ciudad - ', status: "" },
        ciudadesRepre: [],
        selectMunicipioRepre: { value: '', label: ' - Selecciona un Municipio - ', status: "" },
        municipiosRepre: [],
        selectParroquiaRepre: { value: '', label: ' - Selecciona una Parroquia - ', status: "" },
        parroquiasRepre: [],

        calleRepre: { text: "", status: "", disabled: "disabled" },
        casaRepre: { text: "", status: "", disabled: "disabled" },
        emailRepre: { text: "", status: "", disabled: "disabled" },
        telefonosRepre: { text: "Teléfonos", status: "" },
        tlf1Repre: { text: "", status: "", disabled: "disabled" },
        tlf2Repre: { text: "", status: "", disabled: "disabled" },
        tlf3Repre: { text: "", status: "", disabled: "disabled" },
    }

    constructor (props) {
        super(props);  
        consultaGeneral((resp) => {
            tName = resp[2]
            this.setState(resp[0])
            this.props.updState("selectPais", resp[0].selectPais)
            this.props.updState("selectPaisDir", resp[0].selectPais)
            this.props.updState("selectPaisRepre", resp[0].selectPais)
            /* this.props.updState("fecha", this.state.fecha) */
        })
    }

    cambiaSelect = (nombre) => (state) => {
        this.setState({
            [nombre]: state
        }, () => {
            this.props.updState(nombre, state)
        });
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: ""
            }
        });
    }

    cambiaValorBlur = (prop) => ()=> {
        this.props.updState(prop, this.state[prop])
    }

    valorSelectPais = (prop, prop2) => (state) => {
        this.setState({
            [prop]: state,
        },() => {
            consultaEstados (this.state[prop].value, (resp) => {
                this.setState ({ [prop2]: resp });
            })
        });
    }
    
    valorSelectEstado = (prop, ciudad, mun, parr, parrs, ciudades, muns) => (state) => {
        this.setState({
            [prop]: state,
            [ciudad]: { value: '', label: ' - Selecciona una Ciudad - ' },
            [mun]: { value: '', label: ' - Selecciona un Municipio - ' },
            [parr]: { value: '', label: ' - Selecciona una Parroquia - ' },
            [parrs]: [],
            [ciudades]: [{ value: '', label: ' - Cargando Ciudades - ' }],
            [muns]: [{ value: '', label: ' - Cargando Municipios - ' }],
        }, () => {
            consultaCiudMunic (this.state[prop].value, (resp1) => {
                this.setState ({ [ciudades]: resp1 });
            },(resp2) => {
                this.setState ({ [muns]: resp2 });
            })

            this.props.updState(prop, state);
            this.props.updState(ciudad, { value: '', label: ' - Selecciona una Ciudad - ' });
            this.props.updState(mun, { value: '', label: ' - Selecciona un Municipio - ' });
            this.props.updState(parr, { value: '', label: ' - Selecciona una Parroquia - ' });
        });
    }
    
    valorSelectMunicipio = (prop, parr, parrs) => (state) => {
        this.setState({
            [prop]: state,
            [parr]: { value: '', label: ' - Selecciona una Parroquia - ' },
            [parrs]: [{ value: '', label: ' - Cargando Parroquias - ' }]
        }, () => {
            consultaParroquia (this.state[prop].value, (resp) => {
                this.setState ({  [parrs]: resp });
            })
            this.props.updState(prop, state);
            this.props.updState(parr, { value: '', label: ' - Selecciona una Parroquia - ' });
        });
    }

    cambiaFecha = () => (date) =>{
        this.setState({
            fechaFormat: date,
            fecha: date,
            fechaStatus: ""
        },() => {
            calculaEdad(date, (resp) => {
                this.setState(resp[0]);
                this.props.updState("fecha", date);
                this.props.updState("edad", resp[0].edad);
            })
        });
    }

    busquedaDat = (tipo) => (e) => {
        if (e.target.value === "") return null;
        ConsultaDisp (this.state[tipo].text, tipo, (resp)=> {
            if(resp > 0){
                toast.error(`El documento ${(tipo).toUpperCase()} ya está registrado con otro usuario, por favor ingresa otro`,{autoClose: 4000});
                this.setState({
                    [tipo]: { text: "", status: "", disabled: "" }
                }, () => {
                    this.props.updState(tipo, this.state[tipo])
                })
            }else{
                this.props.updState(tipo, this.state[tipo])
            }
        })
    }

    datRepre = () => {
        if (tName !== "EST") return null;

        let { cedRepre, selectNacr, cedulaRepre, pasaporteRepre, nombresRepre, nombre1Repre, nombre2Repre,
            apellidosRepre, apellido1Repre, apellido2Repre, selectPaisRepre, paicesRepre, selectEstadoRepre,
            estadosRepre, selectCiudadRepre, ciudadesRepre, selectMunicipioRepre, municipiosRepre,
            selectParroquiaRepre, parroquiasRepre, calleRepre, casaRepre, emailRepre, telefonosRepre,
            tlf1Repre, tlf2Repre, tlf3Repre } = this.state;

        const nac = [
            { value: 'V', label: 'V' },
            { value: 'E', label: 'E' },
        ];

        return(
            <React.Fragment>
                <Col md ={12} className="custom-mt-10"><div className="custom-alert-warning">Datos del Representante (Sólo si eres menor de edad)</div></Col>
                <Col md ={12} className="custom-mt-10"><div style={{fontSize: 10}} className={cedRepre.status}>{cedRepre.text}</div></Col>

                <Col md ={2} style={{marginTop:1}}>
                    <Select
                        isSearchable ={true}
                        value={selectNacr}
                        onChange={this.cambiaSelect("selectNacr")}
                        options={nac}
                    />
                </Col>
                <Col md ={6}>
                    <div className={cedulaRepre.status}>
                        <input type="text" value={cedulaRepre.text} disabled ={cedulaRepre.disabled} onBlur={this.cambiaValorBlur("cedulaRepre")} onChange={this.cambiaValor("cedulaRepre")} className="form-control" placeholder="CÉDULA"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <input type="text" value={pasaporteRepre.text} disabled ={pasaporteRepre.disabled} onBlur={this.cambiaValorBlur("pasaporteRepre")} onChange={this.cambiaValor("pasaporteRepre")} className="form-control" placeholder="PASAPORTE" title="Número de Pasaporte"/>
                </Col>
                <Col md ={12} /* style={{marginTop:-10}} */><div style={{fontSize: 10}} className={nombresRepre.status}>{nombresRepre.text}</div></Col>
                <Col md ={6}>
                    <div className={nombre1Repre.status}>
                        <input type="text" value={nombre1Repre.text} disabled ={nombre1Repre.disabled} onBlur={this.cambiaValorBlur("nombre1Repre")} onChange={this.cambiaValor("nombre1Repre")} className="form-control" placeholder="PRIMER NOMBRE"/>
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={nombre2Repre.text} disabled ={nombre2Repre.disabled} onBlur={this.cambiaValorBlur("nombre2Repre")} onChange={this.cambiaValor("nombre2Repre")} className="form-control" placeholder="SEGUNDO NOMBRE"/></Col>
            
                <Col md ={12} className="custom-mt-10"><div style={{fontSize: 10}} className={apellidosRepre.status}>{apellidosRepre.text}</div></Col>

                <Col md ={6}>
                    <div className={apellido1Repre.status}>
                        <input type="text" value={apellido1Repre.text} disabled ={apellido1Repre.disabled} onBlur={this.cambiaValorBlur("apellido1Repre")} onChange={this.cambiaValor("apellido1Repre")} className="form-control" placeholder="PRIMER APELLIDO"/>
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={apellido2Repre.text} disabled ={apellido2Repre.disabled} onBlur={this.cambiaValorBlur("apellido2Repre")} onChange={this.cambiaValor("apellido2Repre")} className="form-control" placeholder="SEGUNDO APELLIDO"/></Col>

                <Col md ={12} className="custom-mt-10"><div className="custom-alert-warning">Dirección del Representante</div></Col>

                <Col md ={4} className="custom-mt-10">
                    <Select
                        styles={selectPaisRepre.status}
                        value={selectPaisRepre}
                        onChange={this.valorSelectPais("selectPaisRepre", "estadosRepre")}
                        options={paicesRepre}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={4} className="custom-mt-10" title = "Selecciona un Estado">
                    <Select
                        styles={selectEstadoRepre.status}
                        value={selectEstadoRepre}
                        onChange={this.valorSelectEstado("selectEstadoRepre", "selectCiudadRepre", "selectMunicipioRepre", "selectParroquiaRepre", "parroquiasRepre", "ciudadesRepre", "municipiosRepre")}
                        options={estadosRepre}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={4} className="custom-mt-10" title = "Selecciona una Ciudad">
                    {/* <Select
                        styles={selectCiudadRepre.status}
                        value={selectCiudadRepre}
                        onChange={this.cambiaSelect("selectCiudadRepre")}
                        options={ciudadesRepre}
                        isSearchable ={true}
                    /> */}
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10" title = "Selecciona un Municipio">
                    <Select
                        styles={selectMunicipioRepre.status}
                        value={selectMunicipioRepre}
                        onChange={this.valorSelectMunicipio("selectMunicipioRepre", "selectParroquiaRepre", "parroquiasRepre")}
                        options={municipiosRepre}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10" title = "Selecciona una Parroquia">
                    <Select
                        styles={selectParroquiaRepre.status}
                        value={selectParroquiaRepre}
                        onChange={this.cambiaSelect("selectParroquiaRepre")}
                        options={parroquiasRepre}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={6}className="custom-mt-10">
                    <div className={calleRepre.status}>
                        <input type="text" value={calleRepre.text} disabled ={calleRepre.disabled} onBlur={this.cambiaValorBlur("calleRepre")} onChange={this.cambiaValor("calleRepre")} className="form-control" placeholder="AV/CALLE/SECTOR"/>
                    </div>
                </Col>
                <Col md ={6}className="custom-mt-10">
                    <div className={casaRepre.status}>
                        <input type="text" value={casaRepre.text} disabled ={casaRepre.disabled} onBlur={this.cambiaValorBlur("casaRepre")} onChange={this.cambiaValor("casaRepre")} className="form-control" placeholder="EDF/CASA/QUINTA"/> 
                    </div>
                </Col>

                <Col md ={12} className="custom-mt-20">
                    <div className={emailRepre.status}>
                        <input type="text" value={emailRepre.text} disabled ={emailRepre.disabled} onBlur={this.cambiaValorBlur("emailRepre")} onChange={this.cambiaValor("emailRepre")} className="form-control" placeholder="CORREO ELECTRÓNICO"/>
                    </div>
                </Col>

                <Col md ={12} className="custom-mt-10"><div style={{fontSize: 10}} className={telefonosRepre.status}>{telefonosRepre.text}</div></Col>

                <Col md ={4}>
                    <div className={tlf1Repre.status}>
                        <input type="text" value={tlf1Repre.text} disabled ={tlf1Repre.disabled} onBlur={this.cambiaValorBlur("tlf1Repre")} onChange={this.cambiaValor("tlf1Repre")} className="form-control" placeholder="HABITACIÓN"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <div className={tlf2Repre.status}>
                        <input type="text" value={tlf2Repre.text} disabled ={tlf2Repre.disabled} onBlur={this.cambiaValorBlur("tlf2Repre")} onChange={this.cambiaValor("tlf2Repre")} className="form-control" placeholder="CELULAR"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <div className={tlf3Repre.status}>
                        <input type="text" value={tlf3Repre.text} disabled ={tlf3Repre.disabled} onBlur={this.cambiaValorBlur("tlf3Repre")} onChange={this.cambiaValor("tlf3Repre")} className="form-control" placeholder="OFICINA"/>
                    </div>
                </Col>
            </React.Fragment>
        )
    }

    render() {
        let { selectNac, valorSex, ced, cedula, pasaporte, nombres, nombre1, nombre2, apellidos, apellido1,
            apellido2, paices, selectPais, estados, selectEstado, ciudades, selectCiudad, municipios, selectMunicipio,
            parroquias, selectParroquia, fechaTit, fecha, fechaStatus, etnia, paicesDir, selectPaisDir, estadosDir,
            selectEstadoDir, ciudadesDir, selectCiudadDir, municipiosDir, selectMunicipioDir, parroquiasDir,
            selectParroquiaDir, calle, casa, telefonos, tlf1, tlf2, tlf3 } = this.state;

        const nac = [
            { value: 'V', label: 'V' },
            { value: 'E', label: 'E' },
        ];

        const Sex = [
            { value: 'M', label: 'Masculino' },
            { value: 'F', label: 'Femenino' },
        ];

        return (
            <Row style={{paddingRight: 10}}>
                <Col md ={12} className="custom-mt-10"><div style={{fontSize: 10}} className={ced.status}>{ced.text}</div></Col>
                <Col md ={2} style={{marginTop:1}}>
                    <Select
                        isSearchable ={true}
                        value={selectNac}
                        onChange={this.cambiaSelect("selectNac")}
                        options={nac}
                    />
                </Col>
                <Col md ={3} style={{marginTop:1}}>
                    <div className={cedula.status}>
                        <input type="text" value={cedula.text} disabled ={cedula.disabled} onBlur={this.busquedaDat("cedula")} onChange={this.cambiaValor("cedula")} className="form-control" placeholder="* CÉDULA"/>
                    </div>
                </Col>
                <Col md ={3} style={{marginTop:1}}>
                    <input type="text" value={pasaporte.text} disabled ={pasaporte.disabled} onBlur={this.busquedaDat("pasaporte")} onChange={this.cambiaValor("pasaporte")} className="form-control" placeholder="PASAPORTE" title="Número de Pasaporte"/>
                </Col>
                <Col md ={4} style={{marginTop:1}}>
                    <Select
                        isSearchable ={true}
                        value={valorSex}
                        onChange={this.cambiaSelect("valorSex")}
                        options={Sex}
                    />
                </Col>

                <Col md ={12}><div style={{fontSize: 10}} className={nombres.status}>{nombres.text}</div></Col>

                <Col md ={6}>
                    <div className={nombre1.status}>
                        <input type="text" value={nombre1.text} disabled ={nombre1.disabled} onBlur={this.cambiaValorBlur("nombre1")} onChange={this.cambiaValor("nombre1")} className="form-control" placeholder="*PRIMER NOMBRE"/>
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={nombre2.text} disabled ={nombre2.disabled} onBlur={this.cambiaValorBlur("nombre2")} onChange={this.cambiaValor("nombre2")} className="form-control" placeholder="SEGUNDO NOMBRE"/></Col>

                <Col md ={12} className="custom-mt-10"><div style={{fontSize: 10}} className={apellidos.status}>{apellidos.text}</div></Col>

                <Col md ={6}>
                    <div className={apellido1.status}>
                        <input type="text" value={apellido1.text} disabled ={apellido1.disabled} onBlur={this.cambiaValorBlur("apellido1")} onChange={this.cambiaValor("apellido1")} className="form-control" placeholder="* INGRESA EL PRIMER APELLIDO"/>
                    </div>
                </Col>
                <Col md ={6}><input type="text" value={apellido2.text} disabled ={apellido2.disabled} onBlur={this.cambiaValorBlur("apellido2")} onChange={this.cambiaValor("apellido2")} className="form-control" placeholder="INGRESA EL SEGUNDO APELLIDO"/></Col>
                
                <Col md ={12} className="custom-mt-20"><div className="custom-alert-info">Datos de Nacimiento</div></Col>

                <Col md ={4} className="custom-mt-10">
                    <Select 
                        styles={selectPais.status}
                        value={selectPais}
                        onChange={this.valorSelectPais("selectPais", "estados")}
                        options={paices}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={4} className="custom-mt-10" title = "Selecciona un Estado">
                    <Select
                        styles={selectEstado.status}
                        value={selectEstado}
                        onChange={this.valorSelectEstado("selectEstado", "selectCiudad", "selectMunicipio", "selectParroquia", "parroquias", "ciudades", "municipios")}
                        options={estados}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={4} className="custom-mt-10" title = "Selecciona una Ciudad">
                    {/* <Select
                        styles={selectCiudad.status}
                        value={selectCiudad}
                        onChange={this.cambiaSelect("selectCiudad")}
                        options={ciudades}
                        isSearchable ={true}
                    /> */}
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10" title = "Selecciona un Municipio">
                    <Select
                        styles={selectMunicipio.status}
                        value={selectMunicipio}
                        onChange={this.valorSelectMunicipio("selectMunicipio", "selectParroquia", "parroquias")}
                        options={municipios}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */  className="custom-mt-10" title = "Selecciona una Parroquia">
                    <Select
                        styles={selectParroquia.status}
                        value={selectParroquia}
                        onChange={this.cambiaSelect("selectParroquia")}
                        options={parroquias}
                        isSearchable ={true}
                    />
                </Col>

                <Col md ={6} className="custom-mt-10"><div style={{fontSize: 10}} className={fechaTit.status}>{fechaTit.text}</div></Col>
                <Col md ={6} className="custom-mt-10"><div style={{fontSize: 10}}>Etnia</div></Col>

                <Col md ={6}>
                    <div className={fechaStatus.status}>
                        <DatePicker
                            clearIcon= {<i className="fa fa-times"></i>}
                            calendarIcon= {<i className="fa fa-calendar"></i>}
                            className="form-control"
                            onChange={this.cambiaFecha()}
                            value={fecha}
                        />
                    </div>
                </Col>
                <Col md ={6}>
                    <input type="text" value={etnia.text} disabled ={etnia.disabled} onBlur={this.cambiaValorBlur("etnia")} onChange={this.cambiaValor("etnia")} className="form-control" placeholder="ETNIA"/>
                </Col>

                <Col md ={12} className="custom-mt-20"><div className="custom-alert-info">Dirección de Habitación</div></Col>

                <Col md ={4} className="custom-mt-10">
                    <Select
                        styles={selectPaisDir.status}
                        value={selectPaisDir}
                        onChange={this.valorSelectPais("selectPaisDir", "estadosDir")}
                        options={paicesDir}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={4} className="custom-mt-10">
                    <Select
                        styles={selectEstadoDir.status}
                        value={selectEstadoDir}
                        onChange={this.valorSelectEstado("selectEstadoDir", "selectCiudadDir", "selectMunicipioDir", "selectParroquiaDir", "parroquiasDir", "ciudadesDir", "municipiosDir")}
                        options={estadosDir}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={4} className="custom-mt-10">
                    {/* <Select
                        styles={selectCiudadDir.status}
                        value={selectCiudadDir}
                        onChange={this.cambiaSelect("selectCiudadDir")}
                        options={ciudadesDir}
                        isSearchable ={true}
                    /> */}
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10">
                    <Select
                        styles={selectMunicipioDir.status}
                        value={selectMunicipioDir}
                        onChange={this.valorSelectMunicipio("selectMunicipioDir", "selectParroquiaDir", "parroquiasDir")}
                        options={municipiosDir}
                        isSearchable ={true}
                    />
                </Col>
                <Col md ={6} /* style={{marginTop:-10}} */ className="custom-mt-10">
                    <Select
                        styles={selectParroquiaDir.status}
                        value={selectParroquiaDir}
                        onChange={this.cambiaSelect("selectParroquiaDir")}
                        options={parroquiasDir}
                        isSearchable ={true} />
                </Col>

                <Col md ={6} className="custom-mt-10">
                    <div className={calle.status}>
                        <input type="text" value={calle.text} disabled ={calle.disabled} onBlur={this.cambiaValorBlur("calle")} onChange={this.cambiaValor("calle")} className="form-control" placeholder="* AV/CALLE/SECTOR"/>
                    </div>
                </Col>
                <Col md ={6} className="custom-mt-10">
                    <div className={casa.status}>
                        <input type="text" value={casa.text} disabled ={casa.disabled} onBlur={this.cambiaValorBlur("casa")} onChange={this.cambiaValor("casa")} className="form-control" placeholder="* EDF/CASA/QUINTA"/>
                    </div>
                </Col>

                <Col md ={12} className="custom-mt-10"><div style={{fontSize: 10}} className={telefonos.status}>{telefonos.text}</div></Col>

                <Col md ={4}>
                    <div className={tlf1.status}>
                        <input type="tel" value={tlf1.text} disabled ={tlf1.disabled} onBlur={this.cambiaValorBlur("tlf1")} onChange={this.cambiaValor("tlf1")} className="form-control" placeholder="HABITACIÓN"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <div className={tlf2.status}>
                        <input type="tel" value={tlf2.text} disabled ={tlf2.disabled} onBlur={this.cambiaValorBlur("tlf2")} onChange={this.cambiaValor("tlf2")} className="form-control" placeholder="CELULAR"/>
                    </div>
                </Col>
                <Col md ={4}>
                    <div className={tlf3.status}>
                        <input type="tel" value={tlf3.text} disabled ={tlf3.disabled} onBlur={this.cambiaValorBlur("tlf3")} onChange={this.cambiaValor("tlf3")} className="form-control" placeholder="OFICINA"/>
                    </div>
                </Col>

                {this.datRepre()}
            </Row>
        );
    }
}
 
export default DatosPersonales;


// WEBPACK FOOTER //
// ./src/views/Admision/Content/DatosPersonales.jsx